import React from 'react'
import LayoutComponent from './LayoutComponent'
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';


interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ py: 2 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

function a11yProps(index) {
  return {
    id: `card-layout-tab-${index}`,
    'aria-controls': `card-layout-tabpanel-${index}`,
  };
}

export default function LayoutTabs() {
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Box sx={{ width: '100%' }}>
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs value={value} onChange={handleChange}>
          <Tab label="Menu Layout" {...a11yProps(0)} />
          <Tab label="Our Special Layout" {...a11yProps(1)} />
        </Tabs>
      </Box>
      <CustomTabPanel value={value} index={0}>
      <LayoutComponent menuName={'Menu'}/>
      </CustomTabPanel>
      <CustomTabPanel value={value} index={1}>
      <LayoutComponent menuName={'OurSpecial'}/>
      </CustomTabPanel>
      
    </Box>
  );
}